"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="146151" className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden rounded-lg border-white/5 bg-card/50 shadow-sm">
            <Skeleton className="h-48 w-full rounded-none" />
            <CardHeader className="p-6 pb-4">
              <Skeleton className="mb-3 h-5 w-20" />
              <Skeleton className="h-6 w-full" />
              <Skeleton className="mt-2 h-6 w-2/3" />
            </CardHeader>
            <CardContent className="px-6 pb-4">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="mt-2 h-4 w-full" />
              <Skeleton className="mt-2 h-4 w-4/5" />
            </CardContent>
            <CardFooter className="px-6 pb-6 pt-0">
              <Skeleton className="h-10 w-full" />
            </CardFooter>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="mt-12 text-center text-sm text-muted-foreground font-sans">
        Impossibile caricare i contenuti delle aree di attività.
      </div>;
  }
  if (posts.length === 0) {
    return <div className="mt-12 text-center text-muted-foreground font-sans">
        Nessuna area di attività disponibile al momento.
      </div>;
  }
  return <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden rounded-lg border border-white/10 bg-card/60 backdrop-blur-md shadow-lg transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
          <Link to="/LegalTopicsOverviewPage" className="block overflow-hidden">
            <AspectRatio ratio={16 / 9} className="bg-muted">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-secondary-foreground">
                  <span className="text-xs font-sans tracking-widest uppercase opacity-40">Studio Legale</span>
                </div>}
            </AspectRatio>
          </Link>
          
          <CardHeader className="flex-none p-6 pb-4">
            {post.categories && post.categories.length > 0 && <Badge variant="secondary" className="mb-4 w-fit font-sans text-[10px] uppercase tracking-widest bg-primary/10 text-primary border-none">
                {post.categories[0].name}
              </Badge>}
            <Link to="/LegalTopicsOverviewPage" className="block">
              <CardTitle className="line-clamp-2 font-sans text-2xl font-bold leading-tight text-foreground transition-colors group-hover:text-primary article-title">
                {post.title}
              </CardTitle>
            </Link>
          </CardHeader>
          
          <CardContent className="flex-grow px-6 pb-4">
            <p className="line-clamp-3 font-sans text-sm leading-relaxed text-muted-foreground/90">
              {post.excerpt ? post.excerpt.replace(/<[^>]*>?/gm, '') : ''}
            </p>
          </CardContent>
          
          <CardFooter className="flex-none px-6 pb-6 pt-0">
            <Link to="/LegalTopicsOverviewPage" className="w-full">
              <Button variant="ghost" className="w-full justify-between px-0 font-sans text-xs font-semibold uppercase tracking-widest text-foreground hover:bg-transparent hover:text-primary transition-colors">
                Scopri di più
                <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-2" />
              </Button>
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function Blog() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}